import React from "react";
import { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Divider,
  TextField,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useForm } from "react-hook-form";
import "./style.scss";
import FranchiseDataForm from "./franchise-data-form";
import Bg from "./images/FranchiseTop.webp";

const Franchise = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Grid>
      {/* first box */}
      <Grid>
        <div className="relative h-[35vh] sm:h-[40vh] md:h-[50vh] lg:h-[60vh] flex items-center justify-center overflow-hidden mb-8 md:mb-12 px-4">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-contain bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${Bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          ></div>

          {/* Yellow/Green Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-blue-400/60 via-blue-500/50 to-green-600/40"></div>

          {/* Heading */}
          <h1
            className="relative text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tracking-wider z-10 text-center px-4 max-w-full break-words"
            style={{
              textShadow:
                "4px 4px 8px rgba(0,0,0,0.5), 0 0 20px rgba(0,0,0,0.3)",
              fontFamily: "Arial Black, sans-serif",
              letterSpacing: "0.05em",
              wordWrap: "break-word",
              hyphens: "auto",
            }}
          >
            Franchises
          </h1>
        </div>
      </Grid>
      {/* first box end  */}

      {/* second box */}
      <Grid mt="70px" className="top2">
        <FranchiseDataForm />
      </Grid>
      {/* second box closed */}
    </Grid>
  );
};

export default Franchise;
